<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody>
    <CRow>
      <!-- <div class="col-sm-12 col-xl-2">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="labelPeriode"
            placeholder="Pilih Periode"
            :show-labels="false"
            required
            v-model="periode"
            @select="changePeriode"
            :options="dataTahun"
          ></multiselect>
        </div>
      </div> -->
      <div class="col-sm-12 col-xl-12">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Kategori Pelatihan</label>
          <multiselect
            class="multi-select"
            placeholder="Pilih Kategori Pelatihan"
            v-model="kategoriPelatihan"
            :options="options"
            @select="changeKategoriPelatihan"
            :show-labels="false"
          ></multiselect>
        </div>
      </div>      
      <!-- <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Pelatihan</label>
          <multiselect
            class="multi-select"
            label="nama_pelatihan"
            placeholder="Pilih pelatihan"
            id="pelatihanSelect"
            :show-labels="false"
            required
            v-model="pelatihan"
            @select="changeSertifikasi"
            :options="dataPelatihan"
          ></multiselect>
        </div>
      </div> -->

      <div class="col-sm-12 col-xl-12">
        <!-- <div style="float: left">
          <button class="btn btn-info" @click="download">
            Download Data Pembayaran
          </button>
        </div> -->
        <div style="float: right">          
          <button class="btn btn-info mr-2" @click="resetFilter" >
            Reset Filter
          </button>
          <button class="btn btn-success" @click="changePelatihan">
            Terapkan Filter
          </button>
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode-rpl.service";
import PaymentService from "@/services/finance/payment.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import dataPesertaLmsService from '@/services/pelatihan/data-peserta/data-peserta-lms.service';
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from '@/mixins/exportUtils';

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, AlertUtils],  
  data() {
    return {
      kategoriPelatihan: "",
      options: ['Pelatihan LMS', 'Pelatihan Webinar', 'Pelatihan Offline'],
      formFilter: {
        periode: "",
        value: "",
        id_workshop_pelatihan: "",        
        tipe: 'pembayaran_pelatihan',
      },
      pelatihan: "",
      periode: "",
      kategori_anggota: "",
      dataSertifikasi: [],
      items: [],
      dataPelatihan: [],
      dataTahun: [],
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },

  mounted() {
    this.getPeriode();
  },

  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2017}, (value, index) => 2018 + index)
    }
  },

  methods: {
    changeSertifikasi(value) {
      this.formFilter.id_workshop_pelatihan = value.id_workshop_pelatihan;      
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.kategoriPelatihan = "";
      this.periode = "";
      this.id_workshop_pelatihan = "";
      $("#filterStatusPembayaran").val("");
    },    

    getPelatihan() {
      var vm = this;
      var kategori = vm.kategoriPelatihan;
      if(kategori == "Pelatihan Webinar") {
        WorkshopService.getWebinar(0,1000000,'default','default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan Offline") {
        WorkshopService.getWorkshop(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan LMS") {
        dataPesertaLmsService.getPelatihan(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data;
          vm.dataPelatihan.nama_pelatihan = response.data.title; 
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      }      
    },

    getPeriode() {
      const year = new Date().getFullYear()
      for (let index = 0; index < 3; index++) {
        this.dataTahun.push({
          labelPeriode: year - index,
          value: year - index,
        });
      }
    },

    changePelatihan() {
      var value = {
        id : this.formFilter.id_workshop_pelatihan,
        periode : this.formFilter.periode,
        tipe : this.formFilter.tipe 
      }
      this.$parent.changePelatihan(value);
    },

    changePeriode(value) {
      this.formFilter.periode = value.value
    },

    changeKategoriPelatihan(value) {
      this.kategoriPelatihan = value
      this.getPelatihan();
    },

    download(value) {
      var value = {
        id : this.formFilter.id_workshop_pelatihan,
        periode : this.formFilter.periode,
      }
      this.$parent.download(value);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
